export const ASIDE_WIDTH = 60;

export const SIDEBAR_WIDTH = 418;

export const TITLE_TOOLTIP: Record<string, string> = {
  search: 'ГЕОСПУФ',
  layers: 'СПИСОК ОБЪЕКТОВ',
  quickEntities: 'ПАЛИТРА ОБЪЕКТОВ',
  types: 'СЛОИ',
  operational: 'ОПЕРАТИВНАЯ СИТУАЦИЯ',
  imagery: 'СПУТНИКОВЫЕ СНИМКИ',
};
